import { render, staticRenderFns } from "./StandardAPIReview.vue?vue&type=template&id=344f54f0&scoped=true&"
import script from "./StandardAPIReview.vue?vue&type=script&lang=js&"
export * from "./StandardAPIReview.vue?vue&type=script&lang=js&"
import style0 from "./StandardAPIReview.vue?vue&type=style&index=0&id=344f54f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f54f0",
  null
  
)

export default component.exports